import React from 'react';
import { motion } from 'framer-motion';
import { Import as Passport, Stamp, CheckCircle, XCircle, Users } from 'lucide-react';

type Props = {
  stats: {
    total: number;
    passportUploaded: number;
    visaUploaded: number;
    complete: number;
    missing: number;
  };
};

export const StatsPanel = ({ stats }: Props) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white p-6 rounded-xl shadow-sm"
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="p-2 bg-primary-50 rounded-lg">
            <Users className="text-primary-500" size={24} />
          </div>
          <h3 className="font-medium">Total Pilgrims</h3>
        </div>
        <div className="text-2xl font-bold text-primary-600">{stats.total}</div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="bg-white p-6 rounded-xl shadow-sm"
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="p-2 bg-blue-50 rounded-lg">
            <Passport className="text-blue-500" size={24} />
          </div>
          <h3 className="font-medium">Passport Documents</h3>
        </div>
        <div className="text-2xl font-bold text-blue-600">{stats.passportUploaded}</div>
        <div className="text-sm text-blue-600 mt-2">
          {stats.total > 0 ? Math.round((stats.passportUploaded / stats.total) * 100) : 0}% uploaded
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="bg-white p-6 rounded-xl shadow-sm"
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="p-2 bg-green-50 rounded-lg">
            <Stamp className="text-green-500" size={24} />
          </div>
          <h3 className="font-medium">Visa Documents</h3>
        </div>
        <div className="text-2xl font-bold text-green-600">{stats.visaUploaded}</div>
        <div className="text-sm text-green-600 mt-2">
          {stats.total > 0 ? Math.round((stats.visaUploaded / stats.total) * 100) : 0}% uploaded
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="bg-white p-6 rounded-xl shadow-sm"
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="p-2 bg-red-50 rounded-lg">
            <XCircle className="text-red-500" size={24} />
          </div>
          <h3 className="font-medium">Missing Documents</h3>
        </div>
        <div className="text-2xl font-bold text-red-600">{stats.missing}</div>
        <div className="text-sm text-red-600 mt-2">
          {stats.total > 0 ? Math.round((stats.missing / stats.total) * 100) : 0}% missing
        </div>
      </motion.div>
    </div>
  );
};